import cn from 'classnames'
import { FC, useMemo } from 'react'

import styles from './InitialsPlaceholder.module.scss'

interface IInitialsPlaceholderProps {
  firstName?: string
  lastName?: string
  fullName?: string
  className?: string
  hideInitials?: boolean
}

const getInitials = ({
  firstName = '',
  lastName = '',
  fullName = '',
}: IInitialsPlaceholderProps) => {
  const first = firstName.trim()
  const last = lastName.trim()

  if (first || last) {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
  }

  const fallback = fullName.trim()
  if (!fallback) {
    return ''
  }

  const parts = fallback.split(/\s+/).filter(Boolean)
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase()
  }

  return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase()
}

export const InitialsPlaceholder: FC<IInitialsPlaceholderProps> = ({
  firstName,
  lastName,
  fullName,
  className,
  hideInitials = false,
}) => {
  const initials = useMemo(
    () => getInitials({ firstName, lastName, fullName }),
    [firstName, lastName, fullName]
  )

  return <div className={cn(styles.root, className)}>{hideInitials ? '' : initials || '??'}</div>
}
